<div *ngIf="fileData; else noRowSelected" class="panel-container">

  <div class="detailPanel">
    <span class="detailPanelHeading">
      {{ "fileDisplayName" | translate }} :
    </span>
    <span class="detailPanelValue" title="{{ fileData.fileName }}">
      {{ fileData.fileName }}
    </span>
  </div>

  <div class="panel-content">
    <div class="panel-table-view">
      <div class="panel-table-title">

        <span class="panel-table-titleText panelHeading">
          {{ "documentAssigned" | translate }}
        </span>

        <span class="button-span">
          <modus-button
            (buttonClick)="unassignOwner()"
            button-style="outline"
            color="primary"
          >
            <img
              src="../../../../assets/images/unassign.svg"
              class="assign-unassign-icon"
              alt="Unassign Icon"
            />
            <span class="assign-unassign-button">
              {{ "unassign" | translate }}
            </span>
          </modus-button>
        </span>

      </div>

      <div class="panel-table-data">
        <dms-table
          [tableConfig]="assignedTableConfig"
          [tableData]="assignedTableData"
          #assignedTable
        >
        </dms-table>
      </div>

    </div>
  </div>

  <div class="panel-content">
    <div class="panel-table-view">
      <div class="panel-table-title">

        <span class="panel-table-titleText panelHeading">
          {{ "unassignedUnits" | translate }}
        </span>

        <span class="button-span">
          <modus-button
            (buttonClick)="assignUnit()"
            button-style="outline"
            color="primary"
          >
            <img
              src="../../../../assets/images/assign.svg"
              class="assign-unassign-icon"
              alt="Assign Icon"
            />
            <span class="assign-unassign-button">
              {{ "assign" | translate }}
            </span>
          </modus-button>
        </span>

      </div>

      <div class="panel-table-data">
        <dms-table
          [tableConfig]="unassignedUnitTableConfig"
          [tableData]="unassignedUnitTableData"
          #unassignedUnitTable
        >
        </dms-table>
      </div>

    </div>
  </div>

  <div class="panel-content">
    <div class="panel-table-view">
      <div class="panel-table-title">

        <span class="panel-table-titleText panelHeading">
          {{ "unassignedGroups" | translate }}
        </span>

        <span class="button-span">
          <modus-button
            (buttonClick)="assignGroup()"
            button-style="outline"
            color="primary"
          >
            <img
              src="../../../../assets/images/assign.svg"
              class="assign-unassign-icon"
              alt="Assign Icon"
            />
            <span class="assign-unassign-button">
              {{ "assign" | translate }}
            </span>
          </modus-button>
        </span>

      </div>

      <div class="panel-table-data">
        <dms-table
          [tableConfig]="unassignedGroupTableConfig"
          [tableData]="unassignedGroupTableData"
          #unassignedGroupTable
        >
        </dms-table>
      </div>

    </div>
  </div>
</div>

<ng-template #noRowSelected>
  <div class="panelNoData">
    {{ "noRowSelected" | translate }}
  </div>
</ng-template>
